const TRANSLATE = {
  'permissions.list.title': 'Listado',
  'permissions.list.description': 'Puede ver el listado',
  'permissions.create.title': 'Creación',
  'permissions.create.description': 'Puede crear un(a) nuevo(a)',
  'permissions.edit.title': 'Edición',
  'permissions.edit.description': 'Puede editar un(a) existente',
  'permissions.delete.title': 'Eliminación',
  'permissions.delete.description': 'Puede eliminar un(a) nuevo(a)',
  'permissions.import.title': 'Importación',
  'permissions.import.description': 'Puede hacer una importación por excel',
  'permissions.canEditServiceOrderImport.title': 'Edición por importación',
  'permissions.canEditServiceOrderImport.description': 'Puede realizar ediciones por importación',
  'permissions.export.title': 'Exportación',
  'permissions.export.description': 'Puede hacer una exportación en excel',
  'permissions.setup.title': 'Configuraciones generales',
  'permissions.setup.description': 'Puede alterar campos adicionales, niveles, etc.',
  'permissions.seeDashboard.title': 'Visualización del Dashboard',
  'permissions.seeDashboard.description': 'Puede ver los gráficos del dashboard',
  'permissions.seeComplianceDashboard.title': 'Visualización de conformidad',
  'permissions.seeComplianceDashboard.description': 'Puede ver los gráficos de conformidad del dashboard',
  'permissions.seeMap.title': 'Visualización del mapa',
  'permissions.map.description': 'Visualización del mapa de los usuarios',
  'permissions.createTemplateRecord.title': 'Generación de documentos',
  'permissions.createTemplateRecord.description': 'Puede generar documentos DOCX',
  'permissions.createServiceOrderForOthers.title': 'Creación de actividades para otros usuarios',
  'permissions.createServiceOrderForOthers.description': '**Exclusivo para app mobile**',
  'permissions.useFastServiceOrder.title': 'Creación de actividades rápidas',
  'permissions.useFastServiceOrder.description':
    '**Exclusivo para app mobile**. Al crear actividades en mobile, salta directamente a ejecución.',
  'permissions.createLeanServiceOrder.title': 'Creación de actividades simplificadas',
  'permissions.createLeanServiceOrder.description':
    '**Exclusivo para web**. Habilita un formulario más simplificado de creación de actividades completando el usuario y local automáticamente.',
  'permissions.hideSaveOnLeanServiceOrder.title': 'Permitir solo "Guardar y ejecutar" en la creación simplificada',
  'permissions.hideSaveOnLeanServiceOrder.description':
    '**Exclusivo para web**. Cuando está activada, oculta el botón "Guardar" en la creación simplificada y deja solo "Guardar y ejecutar", evitando registrar actividades sin ejecutarlas. Desactivada (predeterminado): muestra ambos botones.',
  'permissions.createChild.title': 'Creación de actividades hijas en la app',
  'permissions.createChild.description':
    'Permite la creación de actividades hijas en la app, siempre que una actividad es completada',
  'permissions.updateChecklistChildServiceOrder.title':
    'Permite alterar el cuestionario de actividades hijas en la app',
  'permissions.updateChecklistChildServiceOrder.description':
    'Permite alterar el cuestionario de actividades hijas en la app, siempre que una actividad hija está siendo generada',
  'permissions.hideCheckinAndCheckout.title': 'Debe ocultar la información de checkin y checkout',
  'permissions.hideCheckinAndCheckout.description':
    'Oculta el checkin y el checkout en el resumen y PDF de la actividad',
  'permissions.hideAttendanceTime.title': 'Debe ocultar la información de tiempo de atención',
  'permissions.hideAttendanceTime.description': 'Oculta el tiempo de atención en el resumen y PDF de la actividad',
  'permissions.canExecuteFromWeb.title': 'Puede ejecutar actividades desde la web',
  'permissions.canExecuteFromWeb.description': 'Permite que el usuario ejecute actividades en la versión web de Btime',
  'permissions.canEditFinishedServiceOrders.title': 'Puede editar actividades finalizadas',
  'permissions.canEditFinishedServiceOrders.description':
    'Permite que el usuario que ya tiene permiso de edición, pueda editar también actividades ya finalizadas',

  'permissions.bulkCreateServiceOrders.title': 'Creación masiva de actividades',
  'permissions.bulkCreateServiceOrders.description':
    '**Exclusivo de la app móvil** Permite crear varias actividades a la vez.',

  'permissions.createServiceOrderWithoutUser.title': 'Permitir crear actividad sin usuario',
  'permissions.createServiceOrderWithoutUser.description':
    '**Exclusivo para app mobile**. Si está activada: el campo de usuario queda oculto. Si está desactivada: el campo es obligatorio.',

  'permissions.useBtimeAI.title': 'Acceso a Btime AI',
  'permissions.useBtimeAI.description':
    'Permite acceder a Btime AI para obtener insights y respuestas sobre la operación',

  'permissions.refuseServiceOrder.title': 'Rechazar actividades',
  'permissions.refuseServiceOrder.description': '**Exclusivo para app mobile**. Puede rechazar ejecutar una actividad.',

  'permissions.canCreateSlaToServiceOrder.title': 'Crear SLA para actividades',
  'permissions.canCreateSlaToServiceOrder.description': 'Permite crear SLA para actividades',

  'permissions.hideServiceOrdersPlace.title': 'Guardar actividades sin local',
  'permissions.hideServiceOrdersPlace.description': 'Permite guardar actividades sin local',

  'permissions.reviewServiceOrder.title': 'Recuperación de respuestas',
  'permissions.reviewServiceOrder.description': 'Permite recuperar las respuestas de la última actividad',

  'permissions.setupServiceOrderTag.title': 'Tag de Actividad',
  'permissions.setupServiceOrderTag.description': 'Puede crear, editar y eliminar tags de actividad',

  'permissions.editServiceOrdersName.title': 'Editar nombre de la actividad',
  'permissions.editServiceOrdersName.description': 'Crear y editar actividades con nombre',

  'permissions.editServiceOrdersStatus.title': 'Gestión de estado',
  'permissions.editServiceOrdersStatus.description': 'Permite aprobar, cancelar y rechazar',

  'permissions.executePublicServiceOrder.title': 'Envío de actividad pública',
  'permissions.executePublicServiceOrder.description':
    'Permite envío por email para ejecución de actividades por enlaces públicos',

  'permissions.seeOnlySelfServiceOrders.title': 'Visualizar solo las propias actividades',
  'permissions.seeOnlySelfServiceOrders.description': 'Usuario solo podrá visualizar actividades propias',

  'permissions.validateDuplicateServiceOrders.title': 'Validación de actividades duplicadas',
  'permissions.validateDuplicateServiceOrders.description':
    'Al crear actividades en masa, será verificado si ya existen actividades similares',

  'permissions.seeServiceOrdersResume.title': 'Visualización del resumen',
  'permissions.seeServiceOrdersResume.description': 'Usuario puede visualizar el resumen de la actividad',

  'permissions.seeServiceOrdersPublicResumeLink.title': 'Visualización del enlace público',
  'permissions.seeServiceOrdersPublicResumeLink.description':
    'Usuario puede visualizar y copiar el enlace del resumen público',

  'permissions.useResumePdfHeaderImage.title': 'Imagen de encabezado en el PDF de resumen',
  'permissions.useResumePdfHeaderImage.description':
    'Permite agregar o eliminar una imagen de encabezado en el PDF de resumen',

  'permissions.useAutomaticDistribution.title': 'Distribución automática de actividad',
  'permissions.useAutomaticDistribution.description': 'Permite utilizar la distribución automática de actividades',

  'permissions.requirePauseReason.title': 'Hacer motivo de pausa como obligatorio',
  'permissions.requirePauseReason.description': 'Exige un motivo para pausa cada vez que una actividad sea pausada.',

  'permissions.createLocationsPlaceLevel.title': 'Permite crear niveles de locales',
  'permissions.createLocationsPlaceLevel.description': 'Permite crear place levels',

  'permissions.seeRecordIds.title': 'Permite ver los ids de los registros',
  'permissions.seeRecordIds.description': 'Permite ver los ids de los registros por el front',

  'permissions.canViewLabelTriggersCall.title': 'Permite ver etiquetas de error de los triggers en actividades',
  'permissions.canViewLabelTriggersCall.description': 'Permite ver etiquetas de error de los triggers en actividades',

  'permissions.canViewServiceOrderInternalId.title': 'Mostrar #id interno en actividades',
  'permissions.canViewServiceOrderInternalId.description':
    'Muestra el id interno del registro (#id) arriba del código anual de la actividad en tarjetas, modales y tablas.',

  'permissions.seeServiceOrdersTimeline.title': 'Visualización de la línea de tiempo',
  'permissions.seeServiceOrdersTimeline.description':
    'Permite visualizar la pestaña de línea de tiempo en los detalles de la actividad.',

  'permissions.seeServiceOrdersTriggerEvents.title': 'Visualización de los eventos de disparador',
  'permissions.seeServiceOrdersTriggerEvents.description':
    'Permite visualizar la pestaña de eventos de disparador (atajos) en los detalles de la actividad.',

  'permissions.seeServiceOrdersAuditPanel.title': 'Visualización del panel de auditoría',
  'permissions.seeServiceOrdersAuditPanel.description':
    'Permite visualizar la pestaña de auditoría en los detalles de la actividad.',

  'permissions.useNumberedPagination.title': 'Usa paginaciones numeradas',
  'permissions.useNumberedPagination.description':
    'Desactiva scroll infinito y navega por las páginas de las tablas por la navegación',

  'permissions.editFinishedServiceOrdersUser.title': 'Edita usuario de actividades completadas',
  'permissions.editFinishedServiceOrdersUser.description':
    'Permite alterar usuario incluso de actividades que ya fueron completadas o discontinuadas',

  'permissions.setupScreen.title': 'Gestionar vistas de pantallas',
  'permissions.setupScreen.description': 'Permite crear, editar y eliminar vistas de pantallas como kanban',

  'permissions.showExpiredContractWarning.title': 'Mostrar alerta de contrato expirado',
  'permissions.showExpiredContractWarning.description':
    'Muestra una alerta en todos los listados, dashboard y mapa sobre pendencia de contrato.',

  'permissions.showBillingWarning.title': 'Mostrar alerta de factura en abierto',
  'permissions.showBillingWarning.description':
    'Muestra una alerta en todos los listados, dashboard y mapa sobre la existencia de factura en abierto.',

  'permissions.showQRCodeOnModalDetails.title': 'Mostrar aba de QR Codes en Locales y Activos',
  'permissions.showQRCodeOnModalDetails.description':
    'Permite la visualización de la aba de QR Codes en el modal de detalles de Locales y Activos.',

  'permissions.blockPastDates.title': 'Impedir la selección de fechas pasadas',
  'permissions.blockPastDates.description': 'Impede la selección de fechas anteriores al día actual.',

  'permissions.setupDashboard.title': 'Gestionar pantallas de dashboard',
  'permissions.setupDashboard.description': 'Permite crear, editar y eliminar vistas de pantallas del dashboard',

  'permissions.createUserGroup.title': 'Creación de grupos',
  'permissions.createUserGroup.description': 'Puede crear nuevos grupos de usuario',

  'permissions.requireUserGroup.title': 'Grupo obligatorio',
  'permissions.requireUserGroup.description': 'Todo usuario debe formar parte de un grupo',

  'permissions.changePassword.title': 'Cambiar contraseña',
  'permissions.changePassword.description': 'Puede cambiar contraseña de los usuarios',

  'permissions.createChecklistType.title': 'Creación de tipos',
  'permissions.createChecklistType.description': 'Puede crear nuevos tipos de cuestionario',

  'permissions.requireChecklistType.title': 'Tipo obligatorio',
  'permissions.requireChecklistType.description': 'Todo cuestionario debe tener un tipo',

  'permissions.showUndoOption.title': 'Deshacer',
  'permissions.showUndoOption.description':
    'Habilita la opción de deshacer los últimos cambios durante la creación de un cuestionario',

  'permissions.createXsPlaceLevel.title': 'Permite crear niveles de locales',
  'permissions.createXsPlaceLevel.description': 'Permite crear place levels',

  'permissions.seeConfidentialFields.title': 'Permite visualizar campos confidenciales',
  'permissions.seeConfidentialFields.description': 'Permite visualizar campos adicionales confidenciales',

  'permissions.completeNonCompliance.title': 'Completar no conformidad',
  'permissions.completeNonCompliance.description': 'Puede completar no conformidades manualmente',
  'permissions.reopenNonCompliance.title': 'Reabrir no conformidad',
  'permissions.reopenNonCompliance.description': 'Puede reabrir no conformidades manualmente',

  'permissions.useAvailabilityPanel.title': 'Usar Panel de Disponibilidad',
  'permissions.useAvailabilityPanel.description':
    'Habilita el menú y el panel de Disponibilidad de los Lugares en lugar del flujo de No conformidades.',
  'permissions.editPlaceAvailabilityStatus.title': 'Permitir alterar el estado del lugar manualmente',
  'permissions.editPlaceAvailabilityStatus.description':
    'Habilita el botón de alteración manual del estado de disponibilidad en la lista, el kanban y los detalles del lugar, incluyendo arrastrar tarjetas entre columnas.',
  'permissions.notificationAlert.title': 'Habilitar alerta de notificación',
  'permissions.notificationAlert.description': 'Emite una notificación cuando hay una nueva actividad.',
  'permissions.switchChecklistNameByYearlyId.title': 'Cambiar el nombre del cuestionario por el id de la actividad',
  'permissions.switchChecklistNameByYearlyId.description':
    'Muestra el id de la actividad en lugar del nombre del cuestionario en el resumen y en el PDF',

  'permissions.removeGeneralStock.title': 'Ajuste Manual del Inventario General',
  'permissions.removeGeneralStock.description': 'Ajuste manual de cantidad y valor.',

  'permissions.canUseDateKanbanSuggestion.title': 'Sugerencia de fechas en kanban',
  'permissions.canUseDateKanbanSuggestion.description':
    'Sugerencia de fechas de apertura, agendamiento y conclusión en Kanban',

  'permissions.canUseTwilioIntegration.title': 'Twilio',
  'permissions.canUseTwilioIntegration.description': 'Permite acceder y configurar la integración con Twilio',

  'permissions.enablePlaceLock.title': 'Bloqueo de locales',
  'permissions.enablePlaceLock.description': 'Habilita el bloqueo de locales al crear actividad.',

  'permissions.requireUnproductiveServiceOrderSignature.title': 'Firma para Actividad Improductiva',
  'permissions.requireUnproductiveServiceOrderSignature.description':
    'Exige firma al cambiar una actividad a improductiva.',

  'permissions.validateDuplicateServiceOrdersOnApp.title': 'Habilitar alerta de duplicidad en la App',
  'permissions.validateDuplicateServiceOrdersOnApp.description':
    'Muestra una alerta en la app al intentar crear una actividad duplicada.',

  'permissions.configureAssetQrCodeMenuRules.title': 'Configurar reglas de menú de QR Code de Activo por tipo y local',
  'permissions.configureAssetQrCodeMenuRules.description':
    'Permite configurar el menú del QR Code de Activo por tipo de activo y local, habilitando múltiples reglas combinadas en lugar de un único menú para todos los activos.',

  'modules.general.title': 'Configuraciones generales',
  'modules.assets.title': 'Activos',
  'modules.dynamicServiceOrders.title': 'Actividades Dinámicas',
  'modules.stocks.title': 'Inventario',
  'modules.masks.title': 'Máscaras',
  'modules.templates.title': 'Plantillas de documentos',
  'modules.refunds.title': 'Reembolsos',
  'modules.dashboard.title': 'Dashboard',
  'modules.users.title': 'Usuarios',
  'modules.checklists.title': 'Cuestionarios',
  'modules.serviceOrders.title': 'Actividades',
  'modules.maps.title': 'Mapa',
  'modules.fleets.title': 'Flotas',
  'modules.triggers.title': 'Automatizaciones',
  'modules.routines.title': 'Rutinas',
  'modules.segments.title': 'Segmentaciones',
  'modules.locations.title': 'Locales',
  'modules.people.title': 'Personas',
  'modules.forms.title': 'Formularios',
  'modules.qrcode.title': 'QR Codes',
  'modules.nonCompliances.title': 'No conformidades',
  'modules.availability.title': 'Disponibilidad de los Lugares',
  'modules.availability.description': 'Panel de disponibilidad de los lugares',
  'modules.integrations.title': 'Integraciones',
  'modules.qrcode.description': 'Gestión de QR Codes',
  'modules.nonCompliances.description': 'Visualizar todas las no conformidades',
  'modules.publicToken.title': 'Páginas y apis públicas',
  'modules.publicToken.description': 'Visualizar token público',
  'modules.router.description': 'Ruteo',

  title: 'Permisos',
  all: 'Todos',
  enable: 'Activar',
  disable: 'Desactivar',
  errorUpdatingPermission: 'Ocurrió un error al actualizar el permiso'
}

export default TRANSLATE
